import { useEffect, useState, useRef } from 'react';

export default function MediaKitPage() {
  const [gateVisible, setGateVisible] = useState(true);
  const scriptInjected = useRef(false);

  // Expose gate-dismiss to injected scripts
  useEffect(() => {
    window.__mkGrantAccess = () => setGateVisible(false);
    return () => { delete window.__mkGrantAccess; };
  }, []);

  // Inject gate scripts directly — bypasses dangerouslySetInnerHTML script suppression
  useEffect(() => {
    if (!gateVisible || scriptInjected.current) return;
    scriptInjected.current = true;
    const s = document.createElement('script');
    s.id = 'mk-gate-script';
    s.textContent = `
var sel=new Set();
var blocked=['gmail.com','yahoo.com','hotmail.com','outlook.com','icloud.com','aol.com','live.com','msn.com','me.com','yahoo.co.uk','hotmail.co.uk'];
var consented=false;
async function handleOtpSubmit(){
  var code=document.getElementById('otp-input').value.trim();
  if(!code)return;
  var btn=document.getElementById('otp-btn');
  var err=document.getElementById('otp-err');
  err.style.display='none';
  btn.disabled=true;btn.textContent='Verifying...';
  try{
    var r=await fetch('https://opportunitypost.com/api/media-kit-verify',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({otp_code:code})});
    if(r.ok){window.__mkGrantAccess&&window.__mkGrantAccess();}
    else{err.style.display='block';btn.disabled=false;btn.textContent='Access Media Kit \u2192';}
  }catch(e){err.style.display='block';btn.disabled=false;btn.textContent='Access Media Kit \u2192';}
}
function showOtpScreen(fromForm){
  document.getElementById('form-content').style.display='none';
  var otp=document.getElementById('otp-content');
  otp.style.display='block';
  otp.classList.add('fade-up');
  document.getElementById('otp-from-msg').style.display=fromForm?'block':'none';
  if(!fromForm){var inp=document.getElementById('otp-input');if(inp)inp.focus();}
}
function toggleDD(){
  var dd=document.getElementById('mdd');
  var ch=document.getElementById('mchev');
  var tr=document.getElementById('mtrigger');
  var o=dd.classList.contains('open');
  dd.classList.toggle('open',!o);
  ch.classList.toggle('open',!o);
  tr.classList.toggle('open',!o);
}
document.addEventListener('click',function(e){
  var w=document.getElementById('mwrap');
  if(w&&!w.contains(e.target)){
    var dd=document.getElementById('mdd');
    var ch=document.getElementById('mchev');
    var tr=document.getElementById('mtrigger');
    if(dd)dd.classList.remove('open');
    if(ch)ch.classList.remove('open');
    if(tr)tr.classList.remove('open');
  }
});
function pick(el,v){
  if(sel.has(v)){sel.delete(v);el.classList.remove('sel');el.querySelector('.chk').textContent='';}
  else{sel.add(v);el.classList.add('sel');el.querySelector('.chk').textContent='\u2713';}
  renderTags();
}
function renderTags(){
  var w=document.getElementById('tags');
  var t=document.getElementById('mtext');
  if(!w||!t)return;
  w.innerHTML='';
  sel.forEach(function(v){
    var d=document.createElement('div');
    d.className='tag';
    d.innerHTML=v+'<span class="tag-x" onclick="rmTag(this.parentNode.firstChild.textContent)">\u00d7</span>';
    d.firstChild.nodeValue=v;
    w.appendChild(d);
  });
  t.textContent=sel.size?sel.size+' service'+(sel.size>1?'s':'')+' selected':'Select one or more services';
  document.getElementById('mtrigger').classList.toggle('has-sel',sel.size>0);
}
function rmTag(v){
  sel.delete(v);
  document.querySelectorAll('.multi-opt').forEach(function(el){
    if(el.dataset.val===v){el.classList.remove('sel');el.querySelector('.chk').textContent='';}
  });
  renderTags();
}
var jtEl=document.getElementById('job_title');
if(jtEl)jtEl.addEventListener('change',function(){
  document.getElementById('job_title_other').style.display=this.value==='other'?'block':'none';
});
var weEl=document.getElementById('work_email');
if(weEl)weEl.addEventListener('blur',function(){
  var d=(this.value.split('@')[1]||'').toLowerCase();
  document.getElementById('email-err').style.display=blocked.indexOf(d)>-1?'block':'none';
});
function toggleConsent(){
  consented=!consented;
  var b=document.getElementById('cchk');
  b.classList.toggle('on',consented);
  b.textContent=consented?'\u2713':'';
}
async function handleSubmit(){
  var fields=['first_name','last_name','work_email','company','timeline','campaign_goal'];
  var valid=true;
  fields.forEach(function(id){
    var el=document.getElementById(id);
    if(!el)return;
    if(!el.value.trim()){el.style.borderColor='#d94040';valid=false;}
    else{el.style.borderColor='';}
  });
  var jt=document.getElementById('job_title');
  if(!jt.value){jt.style.borderColor='#d94040';valid=false;}
  else jt.style.borderColor='';
  if(sel.size===0){var mt=document.getElementById('mtrigger');mt.style.borderColor='#d94040';valid=false;}
  else{document.getElementById('mtrigger').style.borderColor='';}
  var email=document.getElementById('work_email').value.trim();
  var d=(email.split('@')[1]||'').toLowerCase();
  if(blocked.indexOf(d)>-1){document.getElementById('email-err').style.display='block';valid=false;}
  if(!valid)return;
  var btn=document.getElementById('sub-btn');
  btn.disabled=true;btn.textContent='Sending...';
  var payload={
    first_name:document.getElementById('first_name').value.trim(),
    last_name:document.getElementById('last_name').value.trim(),
    work_email:email,
    company:document.getElementById('company').value.trim(),
    job_title:jt.value==='other'?document.getElementById('job_title_other').value.trim():jt.value,
    services_interested:Array.from(sel),
    campaign_goal:document.getElementById('campaign_goal').value,
    timeline:document.getElementById('timeline').value,
    how_heard:document.getElementById('how_heard').value,
    notes:document.getElementById('notes').value.trim(),
    consent:consented
  };
  try{
    var r=await fetch('/api/media-kit-request',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
    if(r.ok){
      showOtpScreen(true);
    }else{btn.disabled=false;btn.textContent='Send Me the Media Kit \u2192';}
  }catch(e){btn.disabled=false;btn.textContent='Send Me the Media Kit \u2192';}
}
`;
    document.body.appendChild(s);
    return () => {
      const existing = document.getElementById('mk-gate-script');
      if (existing) existing.remove();
    };
  }, [gateVisible]);

  // Font injection
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700,900&f[]=cabinet-grotesk@500,700,800&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      if (document.head.contains(link)) document.head.removeChild(link);
    };
  }, []);

  const html = `
<style>
:root {
  --bg: #f4f0e8;
  --surface: #fbf8f2;
  --surface-2: #ffffff;
  --line: rgba(15,39,66,.12);
  --text: #112033;
  --muted: #667085;
  --navy: #0A0F1E;
  --navy-2: #112e4e;
  --gold: #E8A020;
  --gold-soft: rgba(232,160,32,.14);
  --teal: #00C896;
  --cream: #F7F4EE;
  --radius: 22px;
  --radius-sm: 14px;
  --shadow: 0 18px 50px rgba(17,32,51,.08);
  --max: 1220px;
  --display: 'Cabinet Grotesk', sans-serif;
  --body: 'Satoshi', sans-serif;
}
* { box-sizing: border-box; }
body {
  margin: 0;
  background: linear-gradient(180deg, #f6f2eb 0%, #f1ece4 100%);
  color: var(--text);
  font-family: var(--body);
  line-height: 1.55;
}
.container { width: min(calc(100% - 32px), var(--max)); margin: 0 auto; }
.topbar {
  position: sticky; top: 0; z-index: 20;
  backdrop-filter: blur(14px);
  background: rgba(10,15,30,.92);
  border-bottom: 1px solid rgba(232,160,32,.2);
}
.nav {
  min-height: 78px; display: flex; align-items: center; justify-content: space-between; gap: 24px;
}
.brand { display:flex; align-items:center; gap:12px; font-weight: 800; letter-spacing:-.03em; color: var(--cream); }
.brand-mark {
  width: 38px; height: 38px; border-radius: 50%; background: var(--gold); color: var(--navy); display:grid; place-items:center;
  font-size: 13px; font-family: var(--display); font-weight: 900;
}
.nav-right { display:flex; align-items:center; gap: 18px; }
.nav-contact {
  padding: 10px 20px; border-radius: 999px; background: var(--gold); color: var(--navy);
  font-size: 13px; font-weight: 700; text-decoration: none; letter-spacing: .04em;
}
.nav-note { color: rgba(247,244,238,.6); font-size: 13px; }
.hero { padding: 52px 0 28px; }
.hero-card {
  background: linear-gradient(135deg, rgba(10,15,30,.98), rgba(18,30,60,.92));
  color: var(--cream); border-radius: 34px; padding: 52px; box-shadow: var(--shadow); position: relative; overflow: hidden;
  border: 1px solid rgba(232,160,32,.15);
}
.hero-card:before {
  content:""; position:absolute; border-radius:50%; filter: blur(10px); opacity:.35;
  width: 260px; height: 260px; right:-60px; top:-80px; background: rgba(232,160,32,.35);
}
.hero-card:after {
  content:""; position:absolute; border-radius:50%; filter: blur(10px); opacity:.25;
  width: 320px; height: 320px; left:-90px; bottom:-140px; background: rgba(0,200,150,.18);
}
.eyebrow {
  display:inline-flex; align-items:center; gap:10px; padding:10px 14px; border-radius:999px; border:1px solid rgba(232,160,32,.3);
  font-size: 12px; text-transform: uppercase; letter-spacing:.16em; color: rgba(247,244,238,.8);
  background: rgba(232,160,32,.08);
}
.eyebrow:before { content:""; width:8px; height:8px; border-radius:50%; background: var(--gold); }
.hero-grid { display:grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: start; }
.hero-cover-col { display:flex; align-items:stretch; min-height:100%; }
.hero-cover-img { width:100%; height:100%; min-height:500px; object-fit:cover; border-radius: var(--radius); box-shadow: 0 32px 80px rgba(10,15,30,.45); display:block; }
h1, h2, h3, h4 { font-family: var(--display); letter-spacing:-.04em; margin:0; }
h1 { font-size: clamp(42px, 6vw, 72px); line-height:.92; max-width: 12ch; margin-top: 18px; }
.tagline-hero {
  font-size: 17px; color: var(--gold); font-style: italic; margin: 14px 0 0; letter-spacing: .01em; line-height: 1.5;
}
.hero-copy p { max-width: 60ch; color: rgba(247,244,238,.75); font-size: 17px; margin: 14px 0 0; }
.hero-points { display:grid; grid-template-columns: repeat(2,1fr); gap: 18px; margin-top: 32px; }
.hero-point {
  padding: 24px; border-radius: 18px; background: rgba(255,255,255,.05); border: 1px solid rgba(232,160,32,.12);
}
.hero-point strong { display:block; font-size: 12px; text-transform: uppercase; letter-spacing:.14em; color: var(--gold); margin-bottom: 6px; }
.hero-point span { display:block; font-size: 15px; line-height:1.3; color: rgba(247,244,238,.82); }
.side-panel {
  background: rgba(255,255,255,.06); border: 1px solid rgba(232,160,32,.18); border-radius: 24px; padding: 28px;
}
.side-panel h3 { font-size: 28px; line-height: .98; margin-bottom: 12px; color: var(--cream); }
.side-panel p { color: rgba(247,244,238,.72); margin: 0 0 16px; font-size: 15px; }
.panel-list { list-style:none; padding:0; margin:0; display:grid; gap:12px; }
.panel-list li { display:flex; gap:12px; color: rgba(247,244,238,.8); font-size: 15px; }
.panel-list li:before { content:""; width:8px; height:8px; border-radius:50%; background: var(--gold); margin-top:8px; flex:0 0 auto; }
.stats-bar {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px;
  background: rgba(232,160,32,.15); border: 1px solid rgba(232,160,32,.15);
  border-radius: 20px; overflow: hidden; margin: 28px 0 0;
}
.stat {
  background: rgba(10,15,30,.7); padding: 22px 18px; text-align: center;
}
.stat-num { font-size: 36px; font-weight: 900; color: var(--gold); font-family: var(--display); line-height: 1; }
.stat-label { font-size: 12px; text-transform: uppercase; letter-spacing: .14em; color: rgba(247,244,238,.6); margin-top: 6px; }
.section { padding: 36px 0 14px; }
.section-head { display:grid; grid-template-columns: .9fr 1.1fr; gap: 28px; align-items:end; margin-bottom: 22px; }
.section-head h2 { font-size: clamp(32px, 4vw, 52px); line-height: .96; }
.section-head p { color: var(--muted); font-size: 17px; margin:0; max-width: 60ch; }
.tag {
  display:inline-flex; align-items:center; gap:10px; padding:10px 14px; border-radius:999px; border:1px solid var(--line);
  font-size:12px; text-transform:uppercase; letter-spacing:.15em; color: var(--muted); background: rgba(255,255,255,.72);
  margin-bottom: 14px;
}
.tag:before { content:""; width:8px; height:8px; border-radius:50%; background: var(--gold); }
.grid-3 { display:grid; grid-template-columns: repeat(3,1fr); gap: 18px; }
.grid-2 { display:grid; grid-template-columns: repeat(2,1fr); gap: 18px; }
.card {
  background: rgba(255,255,255,.82); border:1px solid var(--line); border-radius: 24px; padding: 28px; box-shadow: 0 6px 20px rgba(17,32,51,.04);
}
.card.featured {
  background: var(--navy); color: var(--cream); border-color: var(--gold);
}
.card.featured .kicker { color: var(--gold); }
.card.featured h3 { color: var(--cream); }
.card.featured p { color: rgba(247,244,238,.72); }
.card.featured .feature-list li { color: var(--cream); }
.card.featured .price { color: var(--gold); }
.card h3 { font-size: 26px; line-height: 1.05; margin-bottom: 10px; }
.card p { color: var(--muted); margin: 0; font-size: 15px; }
.price { font-size: 44px; line-height: 1; margin: 14px 0 10px; font-family: var(--display); font-weight: 900; color: var(--navy); }
.price-note { font-size: 13px; color: var(--muted); margin: 0 0 12px; }
.kicker { font-size:11px; text-transform:uppercase; letter-spacing:.16em; color: var(--muted); margin-bottom: 8px; }
.badge-limited {
  display: inline-flex; padding: 6px 12px; border-radius: 999px; background: var(--gold); color: var(--navy);
  font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .12em; margin-bottom: 10px;
}
.feature-list { margin: 16px 0 0; padding: 0; list-style:none; display:grid; gap:10px; }
.feature-list li { display:flex; gap:10px; color: var(--text); font-size: 14px; }
.feature-list li:before { content:"+"; color: var(--gold); font-weight:900; font-size: 16px; }
.dark-band {
  margin-top: 24px; padding: 40px; border-radius: 30px; background: linear-gradient(180deg, #0A0F1E, #0d1f34); color: var(--cream);
  border:1px solid rgba(232,160,32,.12); box-shadow: var(--shadow);
}
.dark-band p { color: rgba(247,244,238,.72); }
.mock-grid { display:grid; grid-template-columns: repeat(2,1fr); gap: 18px; margin-top: 24px; }
.mock {
  background: #fff; border-radius: 24px; overflow:hidden; border:1px solid var(--line); box-shadow: 0 10px 24px rgba(17,32,51,.06);
}
.mock-head { padding: 18px 20px; border-bottom:1px solid var(--line); display:flex; justify-content:space-between; gap:12px; align-items:center; background: var(--cream); }
.mock-head strong { font-size: 18px; }
.mock-label { font-size:11px; text-transform:uppercase; letter-spacing:.14em; color: var(--muted); }
.mock-body { padding: 20px; background: #fcfbf8; }
.newsletter-demo { border:1px solid var(--line); border-radius: 18px; overflow:hidden; background:#fff; }
.newsletter-top { padding:16px 18px; background: var(--navy); color:#fff; display:flex; justify-content:space-between; align-items:center; }
.newsletter-ad { padding:16px 18px; background: linear-gradient(90deg, rgba(0,200,150,.08), rgba(232,160,32,.1)); border-bottom:1px solid var(--line); }
.newsletter-ad strong { display:block; font-size:20px; margin-bottom:6px; }
.newsletter-lines { padding:18px; display:grid; gap:10px; }
.nline { height:10px; border-radius:999px; background: #e7e3db; }
.nline.w70 { width:70%; } .nline.w85 { width:85%; } .nline.w55 { width:55%; }
.footer-billboard {
  background: linear-gradient(90deg, #0A0F1E, #142b45); color: var(--cream); border-radius: 24px; min-height: 160px; position:relative; overflow:hidden; padding: 28px;
  display:flex; align-items:center; justify-content:space-between; gap:22px;
}
.footer-copy { position:relative; z-index:2; max-width: 60%; }
.footer-copy strong { display:block; font-size:28px; line-height:.98; margin-bottom:10px; font-family: var(--display); }
.footer-copy span { color: rgba(247,243,235,.72); font-size: 14px; }
.pill {
  display:inline-flex; margin-top:12px; padding:10px 16px; border-radius:999px; background: var(--gold); color: var(--navy); font-size:13px; font-weight: 700;
}
.billboard-brand {
  position:relative; z-index:2; background: rgba(255,255,255,.06); border:1px solid rgba(232,160,32,.2); border-radius: 18px; padding: 22px; min-width: 200px; text-align:center;
}
.billboard-brand strong { display:block; font-size: 26px; color: var(--cream); }
.magazine-demo {
  background: linear-gradient(180deg, #0A0F1E, #0d1f34); border-radius: 22px; padding: 20px; min-height: 360px; color: var(--cream); position:relative; overflow:hidden;
}
.magazine-sheet {
  width: 62%; min-height: 300px; border-radius: 18px; background: var(--cream); color: #14253d; padding: 22px; box-shadow: 0 16px 30px rgba(0,0,0,.22);
}
.magazine-sheet h4 { font-size: 26px; line-height: .96; margin-bottom: 14px; }
.ad-box {
  margin-top: 16px; border-radius: 14px; min-height: 140px; background: linear-gradient(135deg, rgba(0,200,150,.12), rgba(232,160,32,.14)); display:grid; place-items:center; text-align:center; padding: 16px;
  border:1px solid rgba(10,15,30,.08);
}
.job-demo { border-radius: 20px; background: #fff; border:1px solid var(--line); overflow:hidden; }
.job-head { padding:18px 20px; background: var(--navy); color:#fff; }
.job-body { padding: 20px; display:grid; gap: 14px; }
.job-card { padding:16px; border-radius:16px; border:1px solid var(--line); background:#fcfbf8; display:grid; gap:8px; }
.job-badge {
  display:inline-flex; padding:6px 12px; border-radius:999px; background: var(--gold-soft); color: #8a641f; font-size:11px; text-transform:uppercase; letter-spacing:.14em; width:fit-content;
}
table {
  width:100%; border-collapse:collapse; overflow:hidden; border-radius: 18px; background: rgba(255,255,255,.82); border:1px solid var(--line);
}
th, td { padding: 16px 18px; text-align:left; border-bottom:1px solid var(--line); font-size: 15px; }
th { font-size:12px; text-transform:uppercase; letter-spacing:.14em; color: var(--muted); background: rgba(255,255,255,.66); }
tr:last-child td { border-bottom:0; }
td strong { color: var(--navy); }
.note { margin-top: 12px; color: var(--muted); font-size: 14px; }
.calendar-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 14px; margin-top: 20px; }
.cal-card {
  background: rgba(255,255,255,.82); border:1px solid var(--line); border-radius: 18px; padding: 18px;
}
.cal-month { font-size: 11px; text-transform: uppercase; letter-spacing: .14em; color: var(--gold); font-weight: 700; margin-bottom: 6px; }
.cal-theme { font-size: 15px; font-weight: 700; line-height: 1.2; color: var(--navy); margin-bottom: 6px; }
.cal-close { font-size: 12px; color: var(--muted); }
.contact-band {
  background: linear-gradient(135deg, #0A0F1E, #0d1f34); color: var(--cream); border-radius: 28px; padding: 40px;
  border: 1px solid rgba(232,160,32,.15); margin-top: 28px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 36px; align-items: center;
}
.contact-band h3 { font-size: 38px; line-height: .95; margin-bottom: 12px; }
.contact-band p { color: rgba(247,244,238,.72); margin: 0 0 20px; }
.contact-list { list-style: none; padding: 0; margin: 0; display: grid; gap: 12px; }
.contact-list li { color: rgba(247,244,238,.85); font-size: 15px; display: flex; gap: 10px; align-items: center; }
.contact-list li span { color: var(--gold); font-weight: 700; min-width: 80px; }
.cta-btn {
  display: inline-flex; padding: 14px 28px; border-radius: 999px; background: var(--gold); color: var(--navy);
  font-weight: 800; font-size: 15px; text-decoration: none; letter-spacing: .04em; margin-top: 8px;
}
.footer { padding: 34px 0 60px; }
.footer-final {
  background: linear-gradient(180deg, #0A0F1E, #060a12); color: var(--cream); border-radius: 28px; padding: 36px;
  display:grid; grid-template-columns: 1fr auto; gap: 18px; align-items: center;
  border: 1px solid rgba(232,160,32,.1);
}
.footer-final h3 { font-size: 36px; line-height: .95; margin-bottom: 10px; }
.footer-final p { margin: 0; color: rgba(247,244,238,.68); max-width: 60ch; font-size: 15px; }
.footer-brand { text-align: right; }
.footer-brand strong { display: block; font-size: 22px; color: var(--gold); font-family: var(--display); }
.footer-brand span { color: rgba(247,244,238,.5); font-size: 12px; text-transform: uppercase; letter-spacing: .14em; }
.footer-address { margin-top: 12px; color: rgba(247,244,238,.5); font-size: 13px; line-height: 1.7; }
@media (max-width: 980px) {
  .hero-grid, .section-head, .grid-3, .grid-2, .mock-grid, .footer-final, .contact-band, .calendar-grid { grid-template-columns: 1fr; }
  .hero-points { grid-template-columns: 1fr; }
  .footer-copy { max-width: 100%; }
  .stats-bar { grid-template-columns: repeat(2,1fr); }
}
</style>


<main>
  <section class="hero container">
    <div class="hero-card">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="eyebrow">Opportunity Post · 2026 Media Kit</span>
          <h1>Where merit is recognized. Opportunity finds its audience.</h1>
          <p class="tagline-hero">Where merit is recognized. Fairness is expected. Opportunity finds its audience.</p>
          <p>Opportunity Post is a premium monthly editorial brand reaching 110,000+ decision-makers across government, healthcare, education, business, technology, and workforce development — with daily and weekly products that keep your brand present year-round.</p>
          <div class="hero-points">
            <div class="hero-point"><strong>Magazine</strong><span>Monthly full-page advertising in a premium editorial environment.</span></div>
            <div class="hero-point"><strong>First Round</strong><span>Daily briefing sponsorship reaching 110K+ professionals every weekday morning.</span></div>
            <div class="hero-point"><strong>Newsletter</strong><span>Weekly and executive-tier sponsorship placements.</span></div>
            <div class="hero-point"><strong>Career Hub</strong><span>Premium employer visibility and talent pipeline access.</span></div>
          </div>
        </div>
        <div class="hero-cover-col">
          <img class="hero-cover-img" src="https://ik.imagekit.io/enrollforge/opcovers/Media%20Kit%20%20Feature%20Cover.webp" alt="" />
        </div>
      </div>
      <div class="stats-bar">
        <div class="stat"><div class="stat-num">110K+</div><div class="stat-label">Monthly Readers</div></div>
        <div class="stat"><div class="stat-num">6</div><div class="stat-label">Editorial Sectors</div></div>
        <div class="stat"><div class="stat-num">12</div><div class="stat-label">Issues Per Year</div></div>
        <div class="stat"><div class="stat-num">5</div><div class="stat-label">Content Products</div></div>
      </div>
    </div>
  </section>

  <section class="section container">
    <span class="tag">Magazine Advertising</span>
    <div class="section-head">
      <h2>Full-page magazine rates.</h2>
      <p>Opportunity Post Monthly is published every month with 40+ pages of premium editorial content. Full-page advertising is the only format — no half-pages, no banners, no compromises.</p>
    </div>
    <div class="grid-3">
      <article class="card">
        <div class="kicker">Single Insertion</div>
        <h3>Full-Page Ad</h3>
        <div class="price">$10,000</div>
        <p class="price-note">Per insertion · One issue</p>
        <p>Premium full-page placement in Opportunity Post Monthly. Your ad appears alongside trusted editorial content reaching 110,000+ monthly readers.</p>
        <ul class="feature-list">
          <li>Full page only — no partial placements</li>
          <li>Video-enabled option available</li>
          <li>Visit Website + Watch Video + Connect With Us buttons</li>
          <li>Listed in Advertisers Index</li>
        </ul>
      </article>
      <article class="card featured">
        <div class="badge-limited">Limited Time Offer</div>
        <div class="kicker">3-Insertion Package</div>
        <h3>Quarterly Partner</h3>
        <div class="price">$20,000</div>
        <p class="price-note" style="color:rgba(247,244,238,.6);">3 issues · 4th insertion FREE · Save $10,000</p>
        <p>Three consecutive monthly insertions plus one free insertion — our limited time offer for new quarterly partners. Ideal for institutions running seasonal campaigns — back to school, enrollment season, hiring pushes.</p>
        <ul class="feature-list">
          <li>3 full-page insertions across 3 issues</li>
          <li>4th insertion absolutely FREE — limited time</li>
          <li>Issue placement priority</li>
          <li>Video-enabled on all placements</li>
          <li>Newsletter mention included</li>
        </ul>
      </article>
      <article class="card">
        <div class="kicker">Annual Partner</div>
        <h3>12-Issue Commitment</h3>
        <div class="price">$78,000</div>
        <p class="price-note">12 issues · Full year presence</p>
        <p>Year-round brand presence in every issue of Opportunity Post. The choice of institutions building lasting relationships with decision-makers across all six sectors.</p>
        <ul class="feature-list">
          <li>12 full-page insertions — one per month</li>
          <li>Premium page placement priority</li>
          <li>Video-enabled on every insertion</li>
          <li>Monthly newsletter sponsorship included</li>
          <li>Featured in annual advertiser spotlight</li>
        </ul>
      </article>
    </div>
  </section>

  <section class="section container">
    <span class="tag">Video-Enabled Advertising</span>
    <div class="section-head">
      <h2>Video inside the magazine.</h2>
      <p>Opportunity Post is the only digital magazine offering in-page video playback through a premium lightbox player. Your video plays inside the magazine experience — no leaving the page, no YouTube ads, no competing content.</p>
    </div>
    <div class="grid-2">
      <article class="card">
        <div class="kicker">Add-On Feature</div>
        <h3>Video-Enabled Page</h3>
        <div class="price">$1,500</div>
        <p class="price-note">Per insertion · Added to any magazine placement</p>
        <p>Add a Watch Video button to your full-page ad. Readers tap it and your video plays in a premium lightbox player — full screen, branded, no distractions. Powered by Alugha, supporting 200+ languages.</p>
        <ul class="feature-list">
          <li>Embedded lightbox video player</li>
          <li>No YouTube branding or competing ads</li>
          <li>Multilingual support — 200+ languages</li>
          <li>Works on desktop and mobile</li>
        </ul>
      </article>
      <article class="card">
        <div class="kicker">Premium Package</div>
        <h3>Video + Full-Page Bundle</h3>
        <div class="price">$11,500</div>
        <p class="price-note">Single insertion with video enabled</p>
        <p>The complete magazine ad experience. Full-page placement plus video lightbox in one package. Your brand, your story, your video — inside one of the most engaging digital magazine formats in the market.</p>
        <ul class="feature-list">
          <li>Full-page ad + video playback</li>
          <li>Visit Website + Watch Video + Connect With Us buttons</li>
          <li>Premium lightbox player</li>
          <li>Listed in Advertisers Index with badge</li>
        </ul>
      </article>
    </div>
  </section>

  <section class="section container">
    <span class="tag">Newsletter Sponsorship</span>
    <div class="section-head">
      <h2>Newsletter advertising rates.</h2>
      <p>Opportunity Post newsletters reach decision-makers in their inbox every morning, every week, and every month. Premium B2B placements with high open rates and a qualified institutional audience.</p>
    </div>
    <table>
      <thead>
        <tr><th>Product</th><th>Cadence</th><th>Audience</th><th>Rate</th><th>Format</th></tr>
      </thead>
      <tbody>
        <tr><td><strong>First Round</strong> — Daily Briefing</td><td>Weekdays</td><td>General professional</td><td>$1,500 per send</td><td>Primary sponsorship · presented-by placement</td></tr>
        <tr><td><strong>Opportunity Unlocked</strong> — Weekly</td><td>Weekly</td><td>Subscribers + members</td><td>$2,000 per send</td><td>Lead sponsorship with 150-word placement</td></tr>
        <tr><td><strong>The Week Ahead</strong> — Executive</td><td>Weekly · Fridays</td><td>C-suite · Institutional leaders</td><td>$3,500 per send</td><td>Exclusive single-sponsor · invite-only readership</td></tr>
        <tr><td><strong>First Round Monthly Bundle</strong></td><td>Monthly · 20 sends</td><td>General professional</td><td>$22,000 per month</td><td>All weekday sends · primary placement every issue</td></tr>
        <tr><td><strong>Category Exclusive</strong></td><td>Custom</td><td>Sector-specific</td><td>Custom</td><td>Own your sector across all Opportunity Post products</td></tr>
      </tbody>
    </table>
    <p class="note">Newsletter audience data, open rates, and click-through benchmarks available upon request. Minimum 2-week booking lead time required.</p>
  </section>

  <section class="section container">
    <span class="tag">First Round · Daily Briefing</span>
    <div class="section-head">
      <h2>The lead generation engine.</h2>
      <p>First Round is Opportunity Post's daily 3-minute briefing — five handpicked stories, one actionable takeaway, delivered every weekday morning. It is the highest-frequency product in the platform and the primary driver of new subscribers and members.</p>
    </div>
    <div class="grid-2">
      <article class="card featured">
        <div class="kicker">Signature Product</div>
        <h3>First Round Daily Sponsorship</h3>
        <div class="price">$1,500</div>
        <p class="price-note" style="color:rgba(247,244,238,.6);">Per send · Monday–Friday</p>
        <p>Primary "Presented By" sponsorship at the top of every First Round briefing. Your brand is the first thing 110,000+ professionals see when they start their day.</p>
        <ul class="feature-list">
          <li>Top-of-briefing "Presented By" placement</li>
          <li>150-word sponsor message with link</li>
          <li>Logo in briefing header</li>
          <li>AI-voiced audio briefing — your sponsorship is read aloud</li>
          <li>Available Monday through Friday</li>
        </ul>
      </article>
      <article class="card">
        <div class="kicker">Monthly Bundle</div>
        <h3>First Round Monthly Package</h3>
        <div class="price">$22,000</div>
        <p class="price-note">Per month · All 20 weekday sends</p>
        <p>Own every First Round send for an entire month. Maximum frequency, maximum brand recall. The choice of institutions running active hiring campaigns or enrollment pushes.</p>
        <ul class="feature-list">
          <li>All 20 weekday sends — primary placement every issue</li>
          <li>Save $8,000 vs individual sends</li>
          <li>Category exclusivity during sponsorship month</li>
          <li>Bonus — one Opportunity Unlocked weekly placement included</li>
          <li>Performance report at end of month</li>
        </ul>
      </article>
    </div>
  </section>

  <section class="section container">
    <span class="tag">Category &amp; Newsroom Sponsorship</span>
    <div class="section-head">
      <h2>Own your sector.</h2>
      <p>Opportunity Post covers six editorial sectors — Education, Healthcare, Government, Business &amp; Finance, Technology &amp; AI, and Workforce &amp; Labor. Category sponsorship puts your brand exclusively inside the sector your audience reads every day.</p>
    </div>
    <div class="grid-2">
      <article class="card featured">
        <div class="kicker">Sector Exclusive</div>
        <h3>Category Exclusive Sponsorship</h3>
        <div class="price">$3,500</div>
        <p class="price-note" style="color:rgba(247,244,238,.6);">Per month · One sponsor per sector</p>
        <p>Own one editorial sector entirely. Your banner appears on every page, every article, every briefing within your chosen category. One sponsor per sector — no competition, no rotation.</p>
        <ul class="feature-list">
          <li>Exclusive — no other sponsors in your sector</li>
          <li>Banner on all sector category pages</li>
          <li>Logo in sector header</li>
          <li>Mentioned in sector newsletter briefings</li>
          <li>Available sectors: Education, Healthcare, Government, Business, Technology, Workforce</li>
        </ul>
      </article>
      <article class="card">
        <div class="kicker">Rotation Placement</div>
        <h3>Newsroom Billboard Rotation</h3>
        <div class="price">$1,250</div>
        <p class="price-note">Per month · Shared rotation across all sectors</p>
        <p>Your brand rotates across the footer billboard position on all Newsroom and category pages. Premium visibility at a shared rate — ideal for brands seeking broad reach across all six sectors simultaneously.</p>
        <ul class="feature-list">
          <li>Rotation across all 6 sector pages</li>
          <li>Footer billboard placement — logo, headline, CTA button</li>
          <li>Multiple sponsors share the rotation</li>
          <li>Upgrade to sector exclusive anytime</li>
        </ul>
      </article>
    </div>
    <p class="note">Category exclusivity is first-come, first-served per month. Booking closes 10 days before the start of each month. Contact us to check sector availability.</p>
  </section>

  <section class="section container">
    <span class="tag">Career Hub</span>
    <div class="section-head">
      <h2>Employer visibility packages.</h2>
      <p>Career Hub is not a commodity job board. Every listing is reviewed and approved by the Opportunity Post editorial team. Employers reach a curated audience of professionals, graduates, and career-changers across six sectors.</p>
    </div>
    <table>
      <thead>
        <tr><th>Package</th><th>Listings</th><th>Duration</th><th>Price</th><th>Includes</th></tr>
      </thead>
      <tbody>
        <tr><td><strong>Standard Post</strong></td><td>1</td><td>45 days</td><td>$350</td><td>Single listing · editorial review · standard placement</td></tr>
        <tr><td><strong>Premium Post</strong></td><td>1</td><td>90 days</td><td>$650</td><td>Extended run · featured placement · employer badge</td></tr>
        <tr><td><strong>Executive Package</strong></td><td>3</td><td>90 days each</td><td>$1,500</td><td>3 listings · featured placement · employer spotlight section</td></tr>
        <tr><td><strong>Employer Partner</strong></td><td>Unlimited</td><td>12 months</td><td>$5,000</td><td>Unlimited listings · top placement · logo in Career Hub header · featured in newsletter</td></tr>
      </tbody>
    </table>
    <p class="note">Volume discounts available for institutions posting 10+ roles. Contact us for custom employer partnership pricing.</p>
  </section>

  <section class="section container">
    <span class="tag">Add-On Services</span>
    <div class="section-head">
      <h2>Extended partnership services.</h2>
      <p>Beyond advertising, Opportunity Post offers institutional partnership services that connect your brand to students, graduates, and early-career professionals through the First Briefcase pipeline.</p>
    </div>
    <div class="grid-3">
      <article class="card">
        <div class="kicker">Technical Integration</div>
        <h3>XML Job Feed Integration</h3>
        <div class="price">From $1,500</div>
        <p>Automate your job posting pipeline. Your ATS feeds directly into Career Hub via XML. New roles post automatically, no manual entry required.</p>
        <ul class="feature-list">
          <li>ATS integration setup</li>
          <li>Automated feed management</li>
          <li>Custom pricing based on feed complexity</li>
        </ul>
      </article>
      <article class="card">
        <div class="kicker">Student Pipeline</div>
        <h3>Internship &amp; Student Sponsorship</h3>
        <div class="price">From $2,500</div>
        <p>Reach students through First Briefcase and Student Signal. Sponsor internship categories, fund pathway programs, or partner on campus recruiting initiatives.</p>
        <ul class="feature-list">
          <li>First Briefcase category sponsorship</li>
          <li>Student Signal placement</li>
          <li>EnrollForge partner access</li>
        </ul>
      </article>
      <article class="card">
        <div class="kicker">Audio Sponsorship</div>
        <h3>First Round Audio Pre-Roll</h3>
        <div class="price">$500</div>
        <p class="price-note">Per episode · Daily Monday–Friday</p>
        <p>10-second audio sponsorship at the start of every First Round daily briefing. High-frequency brand presence with a professional audience starting their day.</p>
        <ul class="feature-list">
          <li>Daily Monday–Friday presence</li>
          <li>Professional AI-voiced briefing</li>
          <li>Bundle with newsletter for maximum reach</li>
        </ul>
      </article>
    </div>
  </section>

  <section class="section container">
    <span class="tag">2026–2027 Issue Calendar</span>
    <div class="section-head">
      <h2>Plan your campaign.</h2>
      <p>Opportunity Post publishes monthly. Each issue has a featured theme that aligns with the national conversation on workforce, education, healthcare, and opportunity.</p>
    </div>
    <div class="calendar-grid">
      <div class="cal-card"><div class="cal-month">August 2026</div><div class="cal-theme">America's Workforce at the Crossroads</div><div class="cal-close">Booking closes July 15</div></div>
      <div class="cal-card"><div class="cal-month">September 2026</div><div class="cal-theme">The Degree Debate</div><div class="cal-close">Booking closes Aug 15</div></div>
      <div class="cal-card"><div class="cal-month">October 2026</div><div class="cal-theme">Healthcare Workforce Crisis</div><div class="cal-close">Booking closes Sep 15</div></div>
      <div class="cal-card"><div class="cal-month">November 2026</div><div class="cal-theme">Government &amp; Public Sector Hiring</div><div class="cal-close">Booking closes Oct 15</div></div>
      <div class="cal-card"><div class="cal-month">December 2026</div><div class="cal-theme">Year in Opportunity — Annual Review</div><div class="cal-close">Booking closes Nov 15</div></div>
      <div class="cal-card"><div class="cal-month">January 2027</div><div class="cal-theme">The New Economy — What's Next</div><div class="cal-close">Booking closes Dec 15</div></div>
      <div class="cal-card"><div class="cal-month">February 2027</div><div class="cal-theme">Technology &amp; AI in the Workforce</div><div class="cal-close">Booking closes Jan 15</div></div>
      <div class="cal-card"><div class="cal-month">March 2027</div><div class="cal-theme">Business &amp; Entrepreneurship</div><div class="cal-close">Booking closes Feb 15</div></div>
    </div>
  </section>

  <section class="section container">
    <div class="dark-band">
      <span class="eyebrow">Sample Placements</span>
      <div class="section-head" style="margin-top:18px; margin-bottom:18px;">
        <h2 style="color:var(--cream);">What your brand looks like inside Opportunity Post.</h2>
        <p>These mockups show how your creative appears across Opportunity Post products — from the magazine reader to the daily newsletter to the Career Hub.</p>
      </div>
      <div class="mock-grid">
        <article class="mock">
          <div class="mock-head"><strong>Newsletter Sponsorship</strong><span class="mock-label">First Round · Daily</span></div>
          <div class="mock-body">
            <div class="newsletter-demo">
              <div class="newsletter-top"><span>First Round</span><span style="opacity:.7; font-size:13px;">3-minute daily briefing</span></div>
              <div class="newsletter-ad">
                <div class="mock-label">Presented by Your Institution</div>
                <strong>Where the best talent comes from.</strong>
                <div style="font-size:14px; color:#445; margin-top:4px;">Workforce solutions for organizations building tomorrow's pipeline.</div>
              </div>
              <div class="newsletter-lines">
                <div class="nline w85"></div><div class="nline"></div><div class="nline w70"></div><div class="nline"></div><div class="nline w55"></div>
              </div>
            </div>
          </div>
        </article>
        <article class="mock">
          <div class="mock-head"><strong>Newsroom Billboard</strong><span class="mock-label">Rotation Placement</span></div>
          <div class="mock-body">
            <div class="footer-billboard">
              <div class="footer-copy">
                <div class="mock-label" style="color:rgba(247,243,235,.55);">Sponsored Placement</div>
                <strong>Capital that creates communities.</strong>
                <span>Investing locally. Hiring locally. Building stronger futures together.</span>
                <div class="pill">Learn More</div>
              </div>
              <div class="billboard-brand">
                <div class="mock-label" style="color:rgba(247,243,235,.55);">Your Brand</div>
                <strong>PARTNER+</strong>
                <span style="color:rgba(247,243,235,.6); font-size:13px;">Purpose-Driven Partners</span>
              </div>
            </div>
          </div>
        </article>
        <article class="mock">
          <div class="mock-head"><strong>Magazine Full-Page Ad</strong><span class="mock-label">Monthly Issue</span></div>
          <div class="mock-body">
            <div class="magazine-demo">
              <div class="magazine-sheet">
                <div class="mock-label">Opportunity Post Monthly</div>
                <h4>Reach readers in a trusted editorial environment.</h4>
                <div class="ad-box">
                  <div>
                    <div class="mock-label">Full-Page · Video-Enabled</div>
                    <strong style="display:block; font-size:24px; line-height:1.02; font-family: var(--display); margin-top:8px;">Your message here.</strong>
                    <span style="display:block; margin-top:8px; color:var(--muted); font-size:13px;">Visit Website · Watch Video · Connect With Us</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="mock">
          <div class="mock-head"><strong>Career Hub Featured Employer</strong><span class="mock-label">Employer Visibility</span></div>
          <div class="mock-body">
            <div class="job-demo">
              <div class="job-head">
                <strong>Career Hub</strong>
                <div style="opacity:.7; margin-top:4px; font-size:13px;">Premium employer placement · Reviewed by editorial team</div>
              </div>
              <div class="job-body">
                <div class="job-card">
                  <div class="job-badge">Featured Employer</div>
                  <strong style="font-size:20px; line-height:1;">Your Organization Name</strong>
                  <span style="color:var(--muted); font-size:13px;">Senior roles · Your Sector · Multiple locations</span>
                </div>
                <div class="job-card">
                  <strong style="font-size:17px; line-height:1;">Employer Spotlight</strong>
                  <span style="color:var(--muted); font-size:13px;">Priority placement, employer badge, and extended duration for active hiring campaigns.</span>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>

  <section class="section container">
    <span class="tag">Ad Specifications</span>
    <div class="section-head">
      <h2>Creative requirements.</h2>
      <p>All creative is reviewed by the Opportunity Post editorial team before placement. We maintain premium standards across every issue.</p>
    </div>
    <table>
      <thead>
        <tr><th>Format</th><th>Dimensions</th><th>File Type</th><th>Max Size</th><th>Deadline</th></tr>
      </thead>
      <tbody>
        <tr><td><strong>Full-Page Magazine Ad</strong></td><td>2100 × 2850 px · Portrait</td><td>JPG, PNG, WebP</td><td>10 MB</td><td>10 days before publication</td></tr>
        <tr><td><strong>Newsletter Primary</strong></td><td>600 × 200 px</td><td>JPG, PNG</td><td>2 MB</td><td>5 days before send date</td></tr>
        <tr><td><strong>Newsroom Billboard</strong></td><td>1200 × 300 px</td><td>JPG, PNG</td><td>3 MB</td><td>5 days before go-live</td></tr>
        <tr><td><strong>Career Hub Logo</strong></td><td>400 × 400 px · Square</td><td>PNG with transparency</td><td>1 MB</td><td>On account setup</td></tr>
        <tr><td><strong>Video (Watch Video button)</strong></td><td>1920 × 1080 px minimum</td><td>Alugha-hosted URL</td><td>—</td><td>10 days before publication</td></tr>
      </tbody>
    </table>
    <p class="note">All imagery must be high resolution. Opportunity Post reserves the right to request revised creative that does not meet editorial standards.</p>
  </section>

  <section class="section container">
    <div class="contact-band">
      <div>
        <span class="eyebrow" style="border-color:rgba(232,160,32,.3);">Get Started</span>
        <h3 style="margin-top:16px;">Ready to reach 110,000+ opportunity-minded readers?</h3>
        <p>Our advertising team will review your request and respond within 24 business hours. All placements are subject to editorial review and availability.</p>
        <a href="mailto:advertising@opportunitypost.com" class="cta-btn">Start a Campaign →</a>
        <a href="https://ik.imagekit.io/enrollforge/downloads/OpportunityPost-MediaKit2026.pdf" target="_blank" rel="noopener noreferrer" class="cta-btn" style="margin-left:12px; background: transparent; border: 1px solid var(--gold); color: var(--gold);">Download PDF →</a>
        <p style="margin-top:16px; font-size:13px; color:rgba(247,244,238,.5);">Interactive media kit available at <strong style="color:var(--gold);">mediakit.opportunitypost.com</strong> — request access above.</p>
      </div>
      <div>
        <ul class="contact-list">
          <li><span>Email</span> advertising@opportunitypost.com</li>
          <li><span>Website</span> opportunitypost.com</li>
          <li><span>Phone</span> Available upon request</li>
          <li><span>Deadline</span> 10 days prior to each issue</li>
          <li><span>Payment</span> Invoice · ACH · Credit Card · Stripe</li>
        </ul>
      </div>
    </div>
  </section>
</main>

<footer class="footer container">
  <div class="footer-final">
    <div>
      <h3>Opportunity Post</h3>
      <p>Where merit is recognized. Fairness is expected. Opportunity finds its audience.</p>
      <div class="footer-address">
        opportunitypost.com · advertising@opportunitypost.com<br>
        © 2026 Opportunity Post · All rights reserved · Media Kit 2026
      </div>
    </div>
    <div class="footer-brand">
      <strong>OP</strong>
      <span>2026 Media Kit</span>
    </div>
  </div>
</footer>
`;

  const gateHtml = `<style>
*{box-sizing:border-box;margin:0;padding:0}
html,body{height:100%;overflow:hidden;font-family:'Satoshi',sans-serif}
.bg-layer{position:fixed;inset:0;z-index:0;background:linear-gradient(135deg,#0A0F1E 0%,#112e4e 100%);display:flex;align-items:stretch}
.bg-content{width:100%;filter:blur(10px);transform:scale(1.06);opacity:0.85;display:grid;grid-template-columns:1.1fr 0.9fr;gap:0;padding:60px;align-items:center}
.bg-left{padding-right:40px}
.bg-eyebrow{display:inline-flex;align-items:center;gap:8px;padding:8px 14px;border-radius:999px;border:1px solid rgba(232,160,32,.3);font-size:11px;text-transform:uppercase;letter-spacing:.14em;color:rgba(247,244,238,.7);background:rgba(232,160,32,.08);margin-bottom:20px}
.bg-eyebrow:before{content:"";width:7px;height:7px;border-radius:50%;background:#E8A020}
.bg-h1{font-family:'Cabinet Grotesk',sans-serif;font-size:64px;font-weight:900;color:#F7F4EE;line-height:.92;letter-spacing:-.04em;margin-bottom:16px}
.bg-tagline{color:#E8A020;font-style:italic;font-size:16px;margin-bottom:14px}
.bg-desc{color:rgba(247,244,238,.65);font-size:16px;line-height:1.55;max-width:50ch;margin-bottom:28px}
.bg-boxes{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.bg-box{padding:18px;border-radius:16px;background:rgba(255,255,255,.05);border:1px solid rgba(232,160,32,.12)}
.bg-box strong{display:block;font-size:11px;text-transform:uppercase;letter-spacing:.14em;color:#E8A020;margin-bottom:6px}
.bg-box span{display:block;font-size:13px;color:rgba(247,244,238,.7);line-height:1.4}
.bg-cover{width:100%;border-radius:20px;overflow:hidden;box-shadow:0 40px 80px rgba(0,0,0,.4)}
.bg-cover img{width:100%;display:block;object-fit:cover}
.bg-stats{display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:rgba(232,160,32,.15);border-radius:16px;overflow:hidden;margin-top:28px}
.bg-stat{background:rgba(10,15,30,.7);padding:20px 16px;text-align:center}
.bg-stat-num{font-size:32px;font-weight:900;color:#E8A020;font-family:'Cabinet Grotesk',sans-serif;line-height:1}
.bg-stat-label{font-size:10px;text-transform:uppercase;letter-spacing:.12em;color:rgba(247,244,238,.5);margin-top:5px}
.bg-overlay{position:fixed;inset:0;z-index:1;background:rgba(10,15,30,.55)}
.lightbox-outer{position:fixed;inset:0;z-index:10;display:flex;align-items:center;justify-content:center;padding:16px}
.lightbox{background:#fff;border-radius:20px;width:100%;max-width:680px;max-height:calc(100vh - 24px);overflow-y:auto;overflow-x:hidden;box-shadow:0 40px 100px rgba(10,15,30,.5),0 0 0 1px rgba(232,160,32,.2);scrollbar-width:none}
.lightbox::-webkit-scrollbar{display:none}
.lb-inner{padding:28px 36px}
.op-logo{display:flex;align-items:center;gap:10px;margin-bottom:14px}
.op-mark{width:38px;height:38px;border-radius:50%;background:#0A0F1E;color:#E8A020;display:grid;place-items:center;font-size:13px;font-weight:900;flex-shrink:0;font-family:'Cabinet Grotesk',sans-serif}
.op-name{color:#0A0F1E;font-size:15px;font-weight:800;letter-spacing:-.02em;line-height:1.1;font-family:'Cabinet Grotesk',sans-serif}
.op-tagline{color:#667085;font-size:10px;margin-top:2px}
.eyebrow{display:inline-flex;align-items:center;gap:7px;padding:4px 10px;border-radius:999px;border:1px solid rgba(10,15,30,.1);font-size:9px;text-transform:uppercase;letter-spacing:.14em;color:#667085;margin-bottom:8px;background:rgba(232,160,32,.07)}
.eyebrow:before{content:"";width:5px;height:5px;border-radius:50%;background:#E8A020}
.lb-title{color:#0A0F1E;font-size:20px;font-weight:800;letter-spacing:-.03em;margin-bottom:5px;line-height:1.1;font-family:'Cabinet Grotesk',sans-serif}
.lb-sub{color:#667085;font-size:12px;margin-bottom:14px;line-height:1.5}
.divider{height:1px;background:rgba(10,15,30,.07);margin-bottom:14px}
.form-row{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.form-group{display:flex;flex-direction:column;gap:4px;margin-bottom:10px}
.form-label{font-size:9px;text-transform:uppercase;letter-spacing:.12em;color:#0A0F1E;font-weight:700}
.form-hint{font-size:9px;color:#999;margin-top:1px}
.form-input,.form-select,.form-textarea{background:#f8f8f6;border:1.5px solid rgba(10,15,30,.09);border-radius:7px;padding:8px 11px;color:#0A0F1E;font-size:12px;width:100%;font-family:'Satoshi',sans-serif;transition:border-color .2s,background .2s}
.form-input:focus,.form-select:focus,.form-textarea:focus{outline:none;border-color:#E8A020;background:#fff}
.form-input::placeholder,.form-textarea::placeholder{color:rgba(10,15,30,.2)}
.form-select{appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23E8A020' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 13px center;background-color:#f8f8f6;cursor:pointer}
.form-select:focus{background-color:#fff}
.form-textarea{resize:none;height:56px;line-height:1.5}
.other-input{margin-top:7px;display:none}
.err-msg{display:none;font-size:10px;color:#d94040;margin-top:2px;font-weight:600}
.multi-wrap{position:relative}
.multi-trigger{background:#f8f8f6;border:1.5px solid rgba(10,15,30,.09);border-radius:7px;padding:8px 11px;color:rgba(10,15,30,.28);font-size:12px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none;transition:border-color .2s,background .2s}
.multi-trigger:hover,.multi-trigger.open{border-color:#E8A020;background:#fff}
.multi-trigger.has-sel{color:#0A0F1E}
.chev{color:#E8A020;font-size:9px;transition:transform .2s;flex-shrink:0}
.chev.open{transform:rotate(180deg)}
.multi-dd{display:none;position:absolute;bottom:calc(100% + 3px);top:auto;left:0;right:0;background:#fff;border:1.5px solid rgba(232,160,32,.2);border-radius:8px;z-index:300;overflow:hidden;box-shadow:0 8px 28px rgba(10,15,30,.12)}
.multi-dd.open{display:block}
.multi-opt{padding:7px 11px;font-size:12px;color:#0A0F1E;cursor:pointer;display:flex;align-items:center;gap:10px;transition:background .1s;border-bottom:1px solid rgba(10,15,30,.04)}
.multi-opt:last-child{border-bottom:none}
.multi-opt:hover{background:rgba(232,160,32,.05)}
.multi-opt.sel{background:rgba(232,160,32,.07)}
.chk{width:16px;height:16px;border-radius:3px;border:1.5px solid rgba(10,15,30,.15);flex-shrink:0;display:grid;place-items:center;font-size:9px;font-weight:700;color:#0A0F1E;transition:all .12s}
.multi-opt.sel .chk{background:#E8A020;border-color:#E8A020}
.tags{display:flex;flex-wrap:wrap;gap:4px;margin-top:7px}
.tag{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;background:rgba(232,160,32,.1);border:1px solid rgba(232,160,32,.28);border-radius:999px;font-size:11px;color:#0A0F1E;font-weight:600}
.tag-x{cursor:pointer;color:#E8A020;font-size:13px;line-height:1;margin-left:1px}
.consent-row{display:flex;align-items:flex-start;gap:9px;margin:4px 0 12px;padding:9px 11px;background:rgba(232,160,32,.04);border:1px solid rgba(232,160,32,.14);border-radius:7px}
.consent-chk{width:17px;height:17px;border-radius:3px;border:1.5px solid rgba(10,15,30,.15);flex-shrink:0;margin-top:2px;cursor:pointer;background:#fff;display:grid;place-items:center;font-size:9px;font-weight:700;color:#0A0F1E;transition:all .15s}
.consent-chk.on{background:#E8A020;border-color:#E8A020}
.consent-txt{font-size:10px;color:#667085;line-height:1.5;cursor:pointer}
.lb-btn{width:100%;background:#0A0F1E;color:#F7F4EE;border:none;border-radius:8px;padding:13px;font-size:13px;font-weight:800;cursor:pointer;letter-spacing:.04em;transition:all .2s;font-family:'Satoshi',sans-serif}
.lb-btn:hover{background:#E8A020;color:#0A0F1E}
.lb-btn:disabled{opacity:.45;cursor:not-allowed}
.privacy{text-align:center;font-size:10px;color:rgba(10,15,30,.4);margin-top:7px;line-height:1.5}
.lb-footer{display:flex;justify-content:space-between;align-items:center;margin-top:10px;padding-top:10px;border-top:1px solid rgba(10,15,30,.06)}
.lb-footer a{color:#E8A020;font-size:10px;text-decoration:none;border-bottom:1px solid rgba(232,160,32,.25)}
.success{text-align:center;padding:64px 40px;display:none}
.success-icon{width:52px;height:52px;border-radius:50%;background:#E8A020;color:#0A0F1E;display:grid;place-items:center;font-size:20px;font-weight:900;margin:0 auto 18px;font-family:'Cabinet Grotesk',sans-serif}
.success-title{color:#0A0F1E;font-size:22px;font-weight:800;margin-bottom:10px;font-family:'Cabinet Grotesk',sans-serif}
.success-sub{color:#667085;font-size:13px;line-height:1.65;max-width:360px;margin:0 auto}
.have-access-btn{background:transparent;border:1.5px solid #0A0F1E;border-radius:6px;padding:5px 11px;font-size:10px;font-weight:700;color:#0A0F1E;cursor:pointer;letter-spacing:.03em;font-family:'Satoshi',sans-serif;white-space:nowrap;transition:background .15s,color .15s;flex-shrink:0}
.have-access-btn:hover{background:#0A0F1E;color:#fff}
.card-header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px}
.otp-center{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:12px 0}
@keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
.fade-up{animation:fadeUp .25s ease forwards}
@media(max-width:580px){.lb-inner{padding:28px 22px}.form-row{grid-template-columns:1fr}.bg-content{display:none}}
</style>

<div class="bg-layer">
  <div class="bg-content">
    <div class="bg-left">
      <div class="bg-eyebrow">Opportunity Post · 2026 Media Kit</div>
      <div class="bg-h1">Where merit<br>is recognized.</div>
      <div class="bg-tagline">Where merit is recognized. Fairness is expected. Opportunity finds its audience.</div>
      <p class="bg-desc">Opportunity Post is a premium monthly editorial brand reaching 110,000+ decision-makers across government, healthcare, education, business, technology, and workforce development.</p>
      <div class="bg-boxes">
        <div class="bg-box"><strong>Magazine</strong><span>Monthly full-page advertising in a premium editorial environment.</span></div>
        <div class="bg-box"><strong>First Round</strong><span>Daily briefing sponsorship reaching 110K+ professionals every weekday.</span></div>
        <div class="bg-box"><strong>Newsletter</strong><span>Weekly and executive-tier sponsorship placements.</span></div>
        <div class="bg-box"><strong>Career Hub</strong><span>Premium employer visibility and talent pipeline access.</span></div>
      </div>
      <div class="bg-stats">
        <div class="bg-stat"><div class="bg-stat-num">110K+</div><div class="bg-stat-label">Monthly Readers</div></div>
        <div class="bg-stat"><div class="bg-stat-num">6</div><div class="bg-stat-label">Editorial Sectors</div></div>
        <div class="bg-stat"><div class="bg-stat-num">12</div><div class="bg-stat-label">Issues Per Year</div></div>
        <div class="bg-stat"><div class="bg-stat-num">5</div><div class="bg-stat-label">Content Products</div></div>
      </div>
    </div>
    <div class="bg-cover">
      <img src="https://ik.imagekit.io/enrollforge/opcovers/Media%20Kit%20%20Feature%20Cover.webp" alt="Opportunity Post Magazine Cover" />
    </div>
  </div>
</div>
<div class="bg-overlay"></div>

<!-- Single card — two inner states swap in place -->
<div class="lightbox-outer">
  <div class="lightbox">
    <div class="lb-inner">

      <!-- Card header: OP logo + "Have Access Code" button -->
      <div class="card-header">
        <div class="op-logo" style="margin-bottom:0">
          <div class="op-mark">OP</div>
          <div>
            <div class="op-name">Opportunity Post</div>
            <div class="op-tagline">Where merit is recognized. Opportunity finds its audience.</div>
          </div>
        </div>
        <button class="have-access-btn" onclick="showOtpScreen(false)">Have Access Code</button>
      </div>

      <!-- STATE 1: Form content (default) -->
      <div id="form-content">
        <div class="eyebrow">Advertiser Access · 2026 Media Kit</div>
        <h1 class="lb-title">Request the 2026 Media Kit</h1>
        <p class="lb-sub">Explore sponsorship, advertising, and partnership opportunities across Opportunity Post Magazine, Newsletter, Career Hub, First Round, and category verticals. Complete the form and your secure access code will be emailed to you.</p>
        <div class="divider"></div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">First Name *</label>
            <input class="form-input" id="first_name" placeholder="Your first name"/>
          </div>
          <div class="form-group">
            <label class="form-label">Last Name *</label>
            <input class="form-input" id="last_name" placeholder="Your last name"/>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Work Email *</label>
            <input class="form-input" id="work_email" type="email" placeholder="you@company.com"/>
            <span class="form-hint">Work or institutional email required.</span>
            <span class="err-msg" id="email-err">Please use your work email address.</span>
          </div>
          <div class="form-group">
            <label class="form-label">Company / Organization *</label>
            <input class="form-input" id="company" placeholder="Company or institution name"/>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Job Title *</label>
            <select class="form-select" id="job_title">
              <option value="" disabled selected>Select your role</option>
              <option>Founder / Owner / CEO</option>
              <option>President / Executive Leadership</option>
              <option>CMO / VP of Marketing</option>
              <option>Marketing Director / Marketing Manager</option>
              <option>Brand Director / Brand Manager</option>
              <option>Partnerships / Business Development</option>
              <option>Communications / Public Relations</option>
              <option>Talent Acquisition / Recruiting</option>
              <option>HR / People Operations</option>
              <option>Agency / Media Buyer</option>
              <option>Education / Workforce Leader</option>
              <option>Sales / Business Development</option>
              <option value="other">Other</option>
            </select>
            <input class="form-input other-input" id="job_title_other" placeholder="Please share your job title"/>
          </div>
          <div class="form-group">
            <label class="form-label">Campaign Timeline *</label>
            <select class="form-select" id="timeline">
              <option value="" disabled selected>Select a timeline</option>
              <option>Ready to discuss now</option>
              <option>Launching within 30 days</option>
              <option>Planning for 1-3 months</option>
              <option>Planning for 3-6 months</option>
              <option>Exploring future opportunities</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Services You're Interested In *</label>
          <div class="multi-wrap" id="mwrap">
            <div class="multi-trigger" id="mtrigger" onclick="toggleDD()">
              <span id="mtext">Select one or more services</span>
              <span class="chev" id="mchev">&#9660;</span>
            </div>
            <div class="multi-dd" id="mdd">
              <div class="multi-opt" data-val="Opportunity Post Magazine" onclick="pick(this,'Opportunity Post Magazine')"><div class="chk"></div>Opportunity Post Magazine</div>
              <div class="multi-opt" data-val="Newsletter Sponsorship" onclick="pick(this,'Newsletter Sponsorship')"><div class="chk"></div>Newsletter Sponsorship</div>
              <div class="multi-opt" data-val="Career Hub" onclick="pick(this,'Career Hub')"><div class="chk"></div>Career Hub</div>
              <div class="multi-opt" data-val="First Round / Daily Briefing" onclick="pick(this,'First Round / Daily Briefing')"><div class="chk"></div>First Round / Daily Briefing</div>
              <div class="multi-opt" data-val="Category / Vertical Sponsorship" onclick="pick(this,'Category / Vertical Sponsorship')"><div class="chk"></div>Category / Vertical Sponsorship</div>
              <div class="multi-opt" data-val="Custom Campaign or Branded Content" onclick="pick(this,'Custom Campaign or Branded Content')"><div class="chk"></div>Custom Campaign or Branded Content</div>
              <div class="multi-opt" data-val="Full Platform Partnership" onclick="pick(this,'Full Platform Partnership')"><div class="chk"></div>Full Platform Partnership</div>
              <div class="multi-opt" data-val="Not Sure — Recommend the Best Option" onclick="pick(this,'Not Sure — Recommend the Best Option')"><div class="chk"></div>Not Sure — Recommend the Best Option</div>
            </div>
          </div>
          <div class="tags" id="tags"></div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Primary Campaign Goal</label>
            <select class="form-select" id="campaign_goal">
              <option value="" disabled selected>Select a primary goal</option>
              <option>Employer Brand Awareness</option>
              <option>Recruiting / Talent Acquisition</option>
              <option>Student &amp; Early-Career Outreach</option>
              <option>Education / Enrollment Awareness</option>
              <option>Event Promotion</option>
              <option>Thought Leadership / Brand Visibility</option>
              <option>Product or Service Awareness</option>
              <option>Partnership Opportunities</option>
              <option>Not Sure — Recommend the Best Option</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">How Did You Hear About Us?</label>
            <select class="form-select" id="how_heard">
              <option value="" disabled selected>Select an option</option>
              <option>Google Search</option>
              <option>Referral</option>
              <option>LinkedIn</option>
              <option>Social Media</option>
              <option>Opportunity Post Editorial Content</option>
              <option>Newsletter</option>
              <option>First Round / Daily Briefing</option>
              <option>Event or Conference</option>
              <option>Other</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Additional Notes</label>
          <textarea class="form-textarea" id="notes" placeholder="Tell us about your organization, campaign ideas, or any questions you have."></textarea>
        </div>

        <button class="lb-btn" id="sub-btn" onclick="handleSubmit()">Send Me the Media Kit &#8594;</button>

        <div class="consent-row" style="margin-top:10px;margin-bottom:0">
          <div class="consent-chk" id="cchk" onclick="toggleConsent()"></div>
          <span class="consent-txt" onclick="toggleConsent()">Also sign me up for The Week Ahead — the weekly newsletter for professionals who want to stay ahead.</span>
        </div>
        <p class="privacy">Your information will be used only to respond to your request and share relevant Opportunity Post partnership opportunities.</p>

        <div class="lb-footer">
          <a href="/contact">Questions? Contact us</a>
        </div>
      </div><!-- /form-content -->

      <!-- STATE 2: OTP content (hidden by default) -->
      <div id="otp-content" style="display:none">
        <div id="otp-from-msg" style="display:none;background:rgba(232,160,32,.08);border:1px solid rgba(232,160,32,.25);border-radius:8px;padding:10px 14px;margin-bottom:16px;font-size:12px;color:#0A0F1E;line-height:1.6">
          &#10003; <strong>Your access code is on the way.</strong> Check your email and enter it below.
        </div>
        <div class="otp-center">
          <div class="eyebrow" style="margin-bottom:16px">Advertiser Access · 2026 Media Kit</div>
          <h1 class="lb-title" style="text-align:center;margin-bottom:8px">Enter your access code</h1>
          <p class="lb-sub" style="text-align:center;margin-bottom:20px">Enter the 6-digit code sent to your business email.</p>
          <input id="otp-input" class="form-input" placeholder="000000" maxlength="6" autocomplete="one-time-code"
            style="font-size:28px;letter-spacing:.28em;text-align:center;padding:14px 11px;width:100%;max-width:260px;margin-bottom:6px"
            onkeydown="if(event.key==='Enter')handleOtpSubmit()" />
          <span class="err-msg" id="otp-err" style="display:none;text-align:center;margin-bottom:10px">Invalid or expired access code</span>
          <button id="otp-btn" class="lb-btn" style="margin-top:14px" onclick="handleOtpSubmit()">Access Media Kit &#8594;</button>
        </div>
      </div><!-- /otp-content -->

    </div><!-- /lb-inner -->
  </div><!-- /lightbox -->
</div><!-- /lightbox-outer -->

<script>
</script>`;

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: html }} />
      {gateVisible && (
        <div id="mk-gate-container" style={{position:'fixed',inset:0,zIndex:9999}} dangerouslySetInnerHTML={{ __html: gateHtml }} />
      )}
    </div>
  );
}

